import { render, staticRenderFns } from "./DemoSliderVertical.vue?vue&type=template&id=182bd2b5&"
import script from "./DemoSliderVertical.vue?vue&type=script&lang=js&"
export * from "./DemoSliderVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
